import {
  AI_ASSISTANT_VIEW,
  AI_ASSISTANT_THREAD_VIEW,
  AI_ASSISTANT_THREADS_LIST_VIEW,
} from "./route-list"
import { AllThreadsPage } from "@/features/assistant/views/all-threads-page/all-threads-page.tsx"
import AssistantPage from "@/features/assistant/views/assistant-page/assistant-page.tsx"
import { StreamingThreadView } from "@/features/assistant/views/thread-view/straming-thread-view.tsx"
import DesktopSidebarLayout from "@/layouts/desktop-sidebar-layout/desktop-sidebar-layout.tsx"
import NoMenuLayout from "@/layouts/no-menu-layout/no-menu-layout.tsx"

export const assistantRoutes = [
  {
    path: AI_ASSISTANT_THREAD_VIEW,
    element: <StreamingThreadView />,
  },
  {
    path: AI_ASSISTANT_VIEW,
    element: <AssistantPage />,
  },
  {
    path: AI_ASSISTANT_THREADS_LIST_VIEW,
    element: <AllThreadsPage />,
  },
]

const MOBILE_ASSISTANT_ROUTES = [
  {
    element: <NoMenuLayout />,
    children: assistantRoutes,
  },
]

const DESKTOP_ASSISTANT_ROUTES = [
  {
    element: <DesktopSidebarLayout />,
    children: assistantRoutes,
  },
]

export const getAssistantRoutes = (isDesktop: boolean) => {
  return isDesktop ? DESKTOP_ASSISTANT_ROUTES : MOBILE_ASSISTANT_ROUTES
}
